// Android 15+ uses edge-to-edge, but Android WebView does not expose the
// native system-bar insets through env(safe-area-inset-*). Measure them with
// the native plugin, pass them to CSS and keep the WebView itself full-bleed.
import { Capacitor } from "@capacitor/core";
import { EdgeToEdge } from "@capawesome/capacitor-android-edge-to-edge-support";

// Abaixo disto o inset de baixo é a linha de gestos; a partir daí, botões.
const NAV_BOTOES_MIN_PX = 40;

function applyCssInsets(insets = {}) {
  const root = document.documentElement;
  root.classList.add("platform-android");
  // O plugin Android entrega pixels fÃ­sicos; CSS usa pixels lÃ³gicos.
  const density = Math.max(1, Number(window.devicePixelRatio) || 1);
  const toCssPx = (value) => Math.max(0, Number(value) || 0) / density;
  const safeBottom = toCssPx(insets.bottom);

  root.style.setProperty("--safe-top", `${toCssPx(insets.top)}px`);
  root.style.setProperty("--safe-bottom", `${safeBottom}px`);
  root.style.setProperty("--android-nav-padding-bottom", `${Math.max(2, (safeBottom - 6) / 2)}px`);
  // Gestos ou botões? A barra de 3 botões ocupa ~48dp; a linha de gestos,
  // 16–24dp. A TabBar lê a classe (global.css) para descer quase até o
  // rodapé quando só há a linha, como o Instagram, e manter folga sobre os
  // botões quando eles existem.
  const soLinhaDeGestos = safeBottom < NAV_BOTOES_MIN_PX;
  root.classList.toggle("nav-gestos", soLinhaDeGestos);
  root.classList.toggle("nav-botoes", !soLinhaDeGestos);
  root.style.setProperty("--safe-left", `${toCssPx(insets.left)}px`);
  root.style.setProperty("--safe-right", `${toCssPx(insets.right)}px`);
  // Aliases v3.7.3 (--sat/--sab/--sal/--sar): estilos novos leem estes nomes.
  // No Android o valor medido aqui é a fonte única — sobrescreve a cadeia de
  // fallback do global.css (env() é 0 na WebView Android).
  root.style.setProperty("--sat", `${toCssPx(insets.top)}px`);
  root.style.setProperty("--sab", `${safeBottom}px`);
  root.style.setProperty("--sal", `${toCssPx(insets.left)}px`);
  root.style.setProperty("--sar", `${toCssPx(insets.right)}px`);
}

async function enableFullBleedWebView() {
  // Temporarily apply native margins so getInsets() returns the device values.
  await EdgeToEdge.enable();
  const insets = await EdgeToEdge.getInsets();
  applyCssInsets(insets);

  // Remove native margins and overlays. The CSS safe-area shell protects the
  // content, while the WebView background fills behind both system bars.
  // (A janela só fica de fato por baixo das barras em todo Android porque o
  // MainActivity pede isso — antes do 15 o sistema não impõe.)
  await EdgeToEdge.disable();

  // A GUARDA. Os insets medidos só valem se a WebView estiver mesmo por baixo
  // das barras. Se não estiver (APK sem o MainActivity novo, aparelho ou ROM
  // que recusa o edge-to-edge), somar o inset no CSS a uma WebView que já
  // começa abaixo da barra de status é inset em dobro: a TopBar recua 39px à
  // toa e a nav sobe o inset inteiro. Neste caso as barras são desenhadas pelo
  // sistema e o CSS não tem o que reservar: tudo vira 0.
  //
  // Medida um quadro depois do disable(), quando o layout nativo já assentou.
  // `screen.height` é a tela inteira em px lógicos; `innerHeight` é a WebView.
  await new Promise((r) => setTimeout(r, 50));
  if (!webViewOcupaATelaInteira()) {
    console.info("[EdgeToEdge] WebView não é full-bleed; insets do CSS zerados.");
    applyCssInsets({ top: 0, bottom: 0, left: 0, right: 0 });
    document.documentElement.classList.add("barras-nativas");
  }
}

/** Compara a WebView com a tela. Folga de 2px para arredondamento de densidade. */
function webViewOcupaATelaInteira() {
  const tela = Number(window.screen?.height) || 0;
  const vista = Number(window.innerHeight) || 0;
  if (!tela || !vista) return true; // sem medida, não mexe
  return tela - vista <= 2;
}

export async function initEdgeToEdge() {
  if (!Capacitor.isNativePlatform()) return;
  if (Capacitor.getPlatform() !== "android") return;

  try {
    await enableFullBleedWebView();
  } catch (err) {
    console.warn("[EdgeToEdge] full-bleed setup failed:", err);
  }
}

export default initEdgeToEdge;
